import React from 'react';
import Title from './Title';
import {Box, PreviewContainer, Text} from '../../../../styled';
import {Related} from '../../related/Related';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import styled from 'styled-components';
import EntityIcon from '../../../../components/EntityIcon/EntityIcon';

interface SlackProps{
  item: any,
  isPreview?: Boolean,
}

const SlackMessageContainer = styled(Box)`
  padding: 5px;
  display: flex;
  white-space: normal;
  &.Matched{
    background: radial-gradient(100% 100% at 0% 0%, rgba(221, 227, 250, 0.99) 0%, rgba(221, 229, 250, 0.4) 100%);
    margin-left: -5px;
    border-radius: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
`

const SlackMessageItem = ({message, isMatch}:any) => {
  return (
    <SlackMessageContainer className={isMatch ? 'Matched' : ''}>
      <Box maxWidth={170} width={150} mr={25} mb={0}>
        <Text fontSize={20} color="darkViolet">
          {message.user}
        </Text>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        maxWidth="100%"
      >
        <Text fontSize={20} color="darkViolet">
          {message.resultText}
        </Text>
        <FileAttachments files={message.att} />
      </Box>
    </SlackMessageContainer>
  )
}

const Slack = ({ item, isPreview }: SlackProps) => {
  let message = item.messages[item.match_pos || 0];
  let messageText = '';
  if (message) {
    messageText = isPreview ? message.resultText : message.resultSnippet;
  } else if (item.platform === 'slack_original') {
    messageText = isPreview ? item.resultText : item.resultSnippet;
  }
  let channelDisplay = `, #${item.channelDisplayName}`;
  let teamDisplay = item.teamDisplayName ? `@${item.teamDisplayName}` : '';
  if (!item.channelDisplayName) {
    if (item.sender) {
      channelDisplay = teamDisplay ? `, ${item.sender}` : item.sender;
    } else {
      channelDisplay = '';
    }
  }
  if (isPreview) {
    return (
      <Box display="flex" flexDirection="column" overflow="hidden">
        <Box display="flex" alignItems="center">
          <Box mr={20}>
            <EntityIcon entityName={item.pl} />
          </Box>
          <Box>
            <Title sender={item.sender} />
            <Text>
              {`${teamDisplay} ${item.channelDisplayName ? `| #${item.channelDisplayName}` : ''}`}
            </Text>
          </Box>
        </Box>
        <PreviewContainer ml={[0, 60]}>
          <HighlightMarker>
            {item.messages.map((msg:any, i:number) => (
              <SlackMessageItem
                message={msg}
                isMatch={item.messages.length > 1 && item.match_pos === i}
              />
            ))}
          </HighlightMarker>
        </PreviewContainer>
      </Box>
    );
  }
  return (
    <>
      <Title sender={item.sender} />
      <Box
        marginTop="10px"
        marginBottom="20px"
      >
        <HighlightMarker>
          <Text>
            {messageText}
          </Text>
        </HighlightMarker>
      </Box>
      <Related
        data={item.related}
        type={'snippet'}
        headline={'Related to'}
      />
      <FileAttachments files={message.att} />
      <Text variant="muted" size="small">
        {`${teamDisplay}${channelDisplay} | ${item.date}`}
      </Text>
    </>
  )
}

export default Slack;